import(/* webpackMode: "eager" */ "C:\\Github-Runners\\GHA-1.1\\_work\\FBO\\FBO\\Procom.Phoenix.Web\\Phoenix\\microapps\\workflow-hub\\app\\page.tsx");
